import { h } from 'preact';
import styles from './Layout.module.scss';
export function Layout({ sidebar, main, layout, openFilterDrawer, setOpenFilterDrawer }) {
    // Filter Top Layout
    if (layout.filterLayout === 'filterTop') {
        return (h("div", { class: styles.container },
            h("div", { class: styles.layoutBody },
                sidebar && (h("div", { class: styles.filterTop }, sidebar)),
                h("main", { class: styles.main, "data-layout": layout.cardLayout }, main))));
    }
    // Filter Drawer Layout
    if (layout.filterLayout === 'filterDrawer') {
        return (h("div", { class: styles.container },
            openFilterDrawer && (h("div", { class: styles.filterOverlay, onClick: () => setOpenFilterDrawer(false) })),
            h("aside", { class: `${styles.filterDrawer} ${openFilterDrawer ? styles.openDrawer : ''}` }, sidebar),
            h("main", { class: styles.main, "data-layout": layout.cardLayout }, main)));
    }
    // Filter Side Layout (default) — sidebar toggles inline (no drawer/overlay)
    return (h("div", { class: styles.container },
        h("div", { class: openFilterDrawer ? styles.layoutBodySide : styles.layoutBodySideFiltersHidden },
            sidebar && openFilterDrawer && (h("aside", { class: styles.sidebar }, sidebar)),
            h("main", { class: styles.main, "data-layout": layout.cardLayout }, main))));
}
